import { PropTypes } from "prop-types";
import { useEffect, useRef } from "react";
import { ToastContainer } from "react-toastify";

import PubNub from "~/lib/pubnub";

const handleMessage = (payload) => {
  const { event, type, text } = payload.message;

  switch (event) {
    case "reauth":
      window.top.location = "/google_token_expired";
      break;
    case "notification":
      if (type === "success") {
        GlobalContainer.notify(text, "success");
      } else if (type === "error" || type === "danger") {
        GlobalContainer.notify(text, "error");
      }
      break;
    default:
  }
};

const Notifications = ({
  publishKey = "",
  subscribeKey = "",
  channel = "",
  pubNubUuid = "",
}) => {
  const pubnubRef = useRef(null);

  useEffect(() => {
    const client = PubNub.client(publishKey, subscribeKey, pubNubUuid);
    pubnubRef.current = client;

    client.addListener({ message: handleMessage });

    if (channel) {
      client.subscribe({ channels: [channel, "broadcast"] });
    }

    return () => {
      client.removeListener({ message: handleMessage });
      if (channel) {
        client.unsubscribe({ channels: [channel, "broadcast"] });
      }
    };
  }, [publishKey, subscribeKey, channel, pubNubUuid]);

  return (
    <ToastContainer
      stacked
      theme="colored"
      position="top-right"
      autoClose={10000}
      hideProgressBar={false}
      newestOnTop={false}
      closeOnClick
      pauseOnHover
    />
  );
};

Notifications.propTypes = {
  publishKey: PropTypes.string,
  subscribeKey: PropTypes.string,
  channel: PropTypes.string,
  pubNubUuid: PropTypes.string,
};

export default Notifications;
